import React from 'react';
import { ResponsiveModal } from 'components/Modals/ResponsiveModal';
import Label from 'components/form/Label/Label';
import { Button } from 'components/form/Button/index';
import { useViewModalWatcher } from 'hook/helper.hook';

const CloseFooter = props => (
  <Button onClick={props.onCancel} mrphType="primary">
    Close
  </Button>
);

export const FrozenCardModal = props => {
  const modalAttrs = { 'Pop Up Name': 'Frozen Card' };

  useViewModalWatcher(modalAttrs, props.visible);
  const copy = props.modalCopy
    ? props.modalCopy
    : 'Go to Manage Card to un-freeze your card.';

  return (
    <ResponsiveModal
      centered
      headerTitle={'Card is Frozen'}
      wrapClassName={'contentFullHeight'}
      {...props}
      footer={<CloseFooter {...props} />}
    >
      <Label typeHeader={'h2'} className="H2 mH4 margB16">
        Card is Frozen
      </Label>
      <Label type="Body-1" className="mBody-2">
        {copy}
      </Label>
    </ResponsiveModal>
  );
};
